import { TweenMax } from 'gsap';
import transitions from './transitions';
// import drawSVG from '../bonus-files-for-npm-users/DrawSVGPlugin.js'

export default {
  state: {
    transitions: transitions,
    findTransition(key) {
      var t = null;
      this.transitions.forEach(tt => {
        if (tt.key === key) t = tt;
      });
      return t;
    },
  },
  mutations: {
    defaultElement(state, ob) {
      var el = ob.element;
      var stagger = ob.stagger;
      if (stagger) el = el.querySelector('g').children;

      var origin = 'center center';
      var defaults = { opacity: 1, x: 0, y: 0, scale: 1, rotation: 0 };

      if (ob.transition) {
        ob.tween.properties.forEach(p => {
          let tob = { transformOrigin: origin };
          tob[p.prop] = defaults[p.prop];
          TweenMax.set(el, tob);
        });
      }
    },

    animateElement(state, data) {
      var svg = document.querySelector('#' + data.x.file.idImg + ' svg');
      data.all.forEach(e => {
        var el = svg.querySelector('#' + e.id);
        e.element = el;
      });
      data.all.forEach(ob => {
        TweenMax.killTweensOf(ob.element);
        var origin = 'center center';
        var ease = ob.tween.ease || 'Expo.easeInOut';
        var duration = ob.tween.duration || 1;
        var delay = ob.tween.delay || 0;
        var subdelay = ob.tween.subdelay || 0.1;
        var repeat = ob.tween.repeat || 0;
        var el = ob.element;
        var stagger = ob.stagger;
        if (stagger) el = el.querySelector('g').children;
        this.commit('defaultElement', ob);
        if (ob.transition) {
          ob.tween.properties.forEach(p => {
            if (p.value !== '') {
              let _ease = p.ease || ease;
              let _duration = p.duration || duration;
              let _delay = p.delay || delay;
              let tob = { transformOrigin: origin, ease: _ease, delay: +_delay };
              tob[p.prop] = p.value;
              if (stagger) {
                var _subdelay = p.subdelay || subdelay;
                TweenMax.staggerFrom(el, +_duration, tob, _subdelay);
              } else {
                TweenMax.from(el, +_duration, tob);
              }
            }
          });
        }
      });
    },
    stopAnimated(state, list) {
      TweenMax.killAll();
      list.forEach(ob => {
        this.commit('defaultElement', ob);
      });
    },
  },
  getters: {
    transitions(state) {
      return state.transitions;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/player.js